import { render, staticRenderFns } from "./BCKeyAssignmentFront.vue?vue&type=template&id=07d3c291&scoped=true"
import script from "./BCKeyAssignmentFront.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentFront.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentFront.vue?vue&type=style&index=0&id=07d3c291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3c291",
  null
  
)

export default component.exports